import {
  Badge,
  Flex,
  HStack,
  IconButton,
  Tag,
  Text,
  VStack
} from '@chakra-ui/react';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';

const PlateWithSuggestion = ({
  plate,
  registeredVehicleType,
  suggestion,
  isAccepted = false,
  onAccept,
  onReject,
  layout = 'overlay',
  plateLabel = 'Placa'
}) => {
  const showSuggestion = suggestion && !isAccepted;

  if (layout === 'inline') {
    return (
      <VStack align="stretch" spacing={1}>
        <Flex align="center" gap={2} wrap="wrap">
          <Text fontSize="sm" fontWeight="semibold">{plate || 'Não detectada'}</Text>
          {registeredVehicleType && (
            <Tag size="sm" colorScheme="purple" variant="subtle" textTransform="uppercase" fontWeight="bold">
              {registeredVehicleType}
            </Tag>
          )}
        </Flex>
        {showSuggestion && (
          <SuggestionRow
            suggestion={suggestion}
            onAccept={onAccept}
            onReject={onReject}
          />
        )}
      </VStack>
    );
  }

  return (
    <VStack align="flex-start" spacing={1}>
      <Flex align="center" gap={2} wrap="wrap">
        <Badge colorScheme="teal" fontSize="md" px={2} py={1} borderRadius="md">
          {plateLabel}: {plate}
        </Badge>
        {registeredVehicleType && (
          <Tag
            size="md"
            colorScheme="purple"
            variant="solid"
            borderRadius="md"
            textTransform="uppercase"
            fontWeight="bold"
          >
            {registeredVehicleType}
          </Tag>
        )}
      </Flex>
      {showSuggestion && (
        <SuggestionRow
          suggestion={suggestion}
          onAccept={onAccept}
          onReject={onReject}
        />
      )}
    </VStack>
  );
};

const SuggestionRow = ({ suggestion, onAccept, onReject }) => (
  <HStack
    spacing={2}
    opacity={0.72}
    bg="whiteAlpha.800"
    px={2}
    py={1}
    borderRadius="md"
    border="1px dashed"
    borderColor="purple.200"
  >
    <Text fontSize="sm" fontWeight="semibold" color="purple.700">
      {suggestion.plateNumber}
    </Text>
    {suggestion.vehicleType && (
      <Tag size="sm" colorScheme="purple" variant="subtle" textTransform="uppercase">
        {suggestion.vehicleType}
      </Tag>
    )}
    <IconButton
      aria-label="Aceitar sugestão de placa"
      icon={<CheckIcon />}
      size="xs"
      colorScheme="green"
      variant="solid"
      onClick={onAccept}
    />
    <IconButton
      aria-label="Recusar sugestão de placa"
      icon={<CloseIcon boxSize={2.5} />}
      size="xs"
      colorScheme="red"
      variant="outline"
      onClick={onReject}
    />
  </HStack>
);

export default PlateWithSuggestion;
